import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { useSequenceCoachingTip } from 'setup-guide-api/hooks/sequenceCoachingTip';
import { jsx as _jsx } from "react/jsx-runtime";
const ProOnboardingCoachingTipAsync = Loadable({
  loader: () => import('../components/ProOnboardingCoachingTip').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
const ProOnboardingCoachingTipContainer = () => {
  const {
    show
  } = useSequenceCoachingTip();
  return show && /*#__PURE__*/_jsx(ProOnboardingCoachingTipAsync, {});
};
export default ProOnboardingCoachingTipContainer;